import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { Helmet } from 'react-helmet';
import { storageKey } from '@i18n/config';
import { createRootRedirectScript, resolveRootRedirect } from '@i18n/routing';

const IndexPage = ({ location }) => {
  useEffect(() => {
    let savedLocale = null;

    try {
      savedLocale = window.localStorage.getItem(storageKey);
    } catch {
      savedLocale = null;
    }

    const destination = resolveRootRedirect({
      savedLocale,
      browserLanguages: window.navigator.languages || [window.navigator.language],
      search: location.search,
      hash: location.hash,
    });

    navigate(destination, { replace: true });
  }, [location.hash, location.search]);

  return (
    <>
      <Helmet title="Saif Ihsan">
        <html lang="ar" dir="rtl" />
        <meta name="robots" content="noindex, follow" />
        <script type="text/javascript">{createRootRedirectScript()}</script>
      </Helmet>

      <noscript>
        <p>
          <a href="/ar/">العربية</a> | <a href="/en/">English</a>
        </p>
      </noscript>
    </>
  );
};

IndexPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default IndexPage;
